import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import IconButton from '@material-ui/core/IconButton';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
/* Routes */
import { S } from '../../../routes/routes'
/* Sagas Action */
import { actions as notificationActions } from '../../../redux/ducks/notification'
import { safeDeepGetWithType } from 'iotera-base/json';
import { isInteger } from 'iotera-base/object';
import { getWidthColumnByPercent } from '../../../lib/components/function';
import { TablePaginationActionsWrapped, CustomTableCell } from '..';

class GatewayTable extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.goTo = this.goTo.bind(this);
        this.state = {
            tooltipOpen: false,
            page: 0,
            rowsPerPage: 10,
            dropdownOpen: {}
        };
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        let rowsPerPage = event.target.value;
        if (!isInteger(rowsPerPage))
            rowsPerPage = parseInt(rowsPerPage)
        this.setState({ page: 0, rowsPerPage });
    };

    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onMouseEnter(key) {
        let dropdownOpen = Object.assign({}, this.state.dropdownOpen);
        // set dropdown visible 
        dropdownOpen[key] = true;
        this.setState({ dropdownOpen });
    }

    onMouseLeave(key) {
        let dropdownOpen = Object.assign({}, this.state.dropdownOpen);
        // set dropdown hidden 
        dropdownOpen[key] = false;

        this.setState({ dropdownOpen });
    }

    handleAllCheck = event => {
        this.props.onCheckedRole(event.target.checked)
    }

    goTo(link) {
        if (link === 'delete') {
            this.props.showSingleNotification({ message: 'Maaf, fitur hapus role belum tersedia', position: 'tr', level: 'info' });
        } else {
            this.props.history.push(link)
        }
    }

    render() {
        let data = this.props.data;
        let tableWidth = safeDeepGetWithType(this, ['props', 'tableSize', 'width'], 0);
        const { rowsPerPage, page } = this.state;
        let roleRows = []
        Object.keys(data).forEach((key, index) => {
            let cardContent = data[key];
            // get dropdown is open or not
            let dropdownIsOpen = safeDeepGetWithType(this, ['state', 'dropdownOpen', index], false);
            roleRows.push(
                <TableRow key={index} className='table-row-child-iotera'>
                    <TableCell component="th" scope="row" column='id' style={{ textAlign: 'left' }}>
                        <span className='text-uppercase'><b>{cardContent.id}</b></span>
                    </TableCell>
                    <TableCell column='name' style={{ textAlign: 'left' }}>
                        <span><i>{cardContent.name}</i></span>
                    </TableCell>
                    <TableCell column='server' >
                        <span>
                            {cardContent.server}
                        </span>
                    </TableCell>
                    <TableCell column='settings' onMouseLeave={(e) => this.onMouseLeave(index)} style={{ textAlign: 'center' }}>
                        <UncontrolledDropdown isOpen={dropdownIsOpen}>
                            <DropdownToggle tag="div">
                                <IconButton onMouseOver={(e) => this.onMouseEnter(index)} style={{ cursor: 'pointer', padding: 4 }}>
                                    <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                                </IconButton>
                            </DropdownToggle>
                            <DropdownMenu style={{ padding: 0, margin: 0 }}>
                                <DropdownItem style={{ margin: 0 }} onClick={(e) => this.goTo('.' + S + 'edit' + S + cardContent.id)}>
                                    <EditIcon color="inherit" style={{ height: 18, width: 18 }} />
                                    &emsp;<span style={{ marginRight: 20 }}>Edit</span>
                                </DropdownItem>
                                <DropdownItem style={{ margin: 0 }} onClick={(e) => this.goTo('delete')}>
                                    <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />
                                    &emsp;<span style={{ marginRight: 20 }}>Hapus</span>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </TableCell>
                </TableRow >
            )
        }
        )
        return (
            <Table className="table" >
                <TableHead style={{ height: 0 }}>
                    <TableRow>
                        <CustomTableCell column='id' style={{
                            textAlign: 'left', minWidth: getWidthColumnByPercent(25, tableWidth),
                            maxWidth: getWidthColumnByPercent(25, tableWidth)
                        }}><span>Alamat MAC</span></CustomTableCell >
                        <CustomTableCell column='name' style={{
                            textAlign: 'left', minWidth: getWidthColumnByPercent(25, tableWidth),
                            maxWidth: getWidthColumnByPercent(25, tableWidth)
                        }}><span>Nama</span></CustomTableCell >
                        <CustomTableCell column='server' style={{
                            textAlign: 'left', minWidth: getWidthColumnByPercent(40, tableWidth),
                            maxWidth: getWidthColumnByPercent(40, tableWidth)
                        }}><span>LoRA Server</span></CustomTableCell >
                        <CustomTableCell column='settings' style={{
                            textAlign: 'center', minWidth: getWidthColumnByPercent(10, tableWidth),
                            maxWidth: getWidthColumnByPercent(10, tableWidth)
                        }}><span>Aksi</span></CustomTableCell >
                    </TableRow>
                </TableHead>
                <TableBody>
                    {roleRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
                            labelRowsPerPage='Baris terlihat:'
                            rowsPerPageOptions={[5, 10, 25]}
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                                native: true,
                            }}
                            onPageChange={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActionsWrapped}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators(notificationActions, dispatch)
});

export default connect(null, mapDispatchToProps)(GatewayTable);